import ability from './ability'
import { isPlanRestricted, getRequiredPlan, getResourceName, planHasResourcePermission, planHasResourcePermissionAsync } from './planUpgrade'

export const canNavigate = to => to.matched.some(route => {
    const resource = route.meta.resource
    if (!resource) return false

    // Suporte a múltiplos resources separados por pipe (lógica OR), igual ao backend
    if (resource.includes('|')) {
        return resource.split('|').some(r => ability.can(route.meta.action, r))
    }

    return ability.can(route.meta.action, resource)
})

/**
 * Verifica se a navegação está bloqueada por restrição de plano (não por perfil)
 * IMPORTANTE: Diferencia entre bloqueio de plano vs bloqueio de perfil
 * @param {Object} to - Objeto de rota de destino
 * @returns {Object|null} - Retorna informações do bloqueio ou null se não bloqueado
 */
export const isRouteBlockedByPlan = to => {
    const blockedRoute = to.matched.find(route => {
        const resource = route.meta.resource
        if (!resource) return false

        // Suporte a múltiplos resources separados por pipe (lógica OR)
        const resources = resource.includes('|') ? resource.split('|') : [resource]
        const hasPermission = resources.some(r => ability.can(route.meta.action, r))

        // Se tem permissão, não está bloqueado
        if (hasPermission) return false

        // Verifica se é recurso que pode ser restrito por plano
        if (!resources.some(r => isPlanRestricted(r))) return false

        // IMPORTANTE: Verifica se o PLANO tem a permissão
        // Se o plano não tem, é bloqueio de plano
        // Se o plano tem mas o usuário não, é bloqueio de perfil (não mostra mensagem de upgrade)
        return !resources.some(r => planHasResourcePermission(r))
    })

    if (blockedRoute) {
        return {
            resource: blockedRoute.meta.resource,
            requiredPlan: getRequiredPlan(blockedRoute.meta.resource),
            resourceName: getResourceName(blockedRoute.meta.resource),
        }
    }

    return null
}

/**
 * Verifica se a navegação está bloqueada por restrição de plano (versão assíncrona com dupla validação)
 * @param {Object} to - Objeto de rota de destino
 * @returns {Promise<Object|null>}
 */
export const isRouteBlockedByPlanAsync = async to => {
    for (const route of to.matched) {
        const resource = route.meta.resource
        if (!resource) continue

        // Suporte a múltiplos resources separados por pipe (lógica OR)
        const resources = resource.includes('|') ? resource.split('|') : [resource]
        const hasPermission = resources.some(r => ability.can(route.meta.action, r))
        if (hasPermission) continue

        if (!resources.some(r => isPlanRestricted(r))) continue

        // Dupla validação: busca no backend para cada resource
        let planHasAny = false
        for (const r of resources) {
            const planHasIt = await planHasResourcePermissionAsync(r)
            if (planHasIt) {
                planHasAny = true
                break
            }
        }

        if (!planHasAny) {
            const restrictedResource = resources.find(r => isPlanRestricted(r)) || resources[0]
            return {
                resource: restrictedResource,
                requiredPlan: getRequiredPlan(restrictedResource),
                resourceName: getResourceName(restrictedResource),
            }
        }
    }

    return null
}

export const _ = undefined
